module.exports = __webpack_public_path__ + "img/monobank.266381cf.png";